import React, { useRef, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Button } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';
import { HandThumbsUp, HandThumbsDown, Check, CheckCircleFill, XCircleFill } from 'react-bootstrap-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Cookies from 'js-cookie';
import './Ridella/style/style.scss'
import { Information, InformationButton } from './Ridella/Information';
import Explanation from './Ridella/Explanation';
import Statistics from './Ridella/Statistics';
import ShareButton from './Ridella/ShareButton';
// import TodaysDate from './Ridella/TodaysDate';
import { PreGameAlert, PostGameAlert } from './Ridella/InfoAlert';
import Confetti from 'react-confetti'
import { Auth } from "aws-amplify";
import { iconMapping } from './Ridella/IconMapping';
import { useNavigate, Link } from 'react-router-dom'; 
import PuzPopModal from './Ridella/PuzPopModal';


const Ridella = () => {
    const inputRef = useRef(null);
    const [data, setData] = useState({});
    const [message, setMessage] = useState('');
    const [gameOver, setGameOver] = useState(false);
    const [totalGuesses, setTotalGuesses] = useState(0);
    const [showConfetti, setShowConfetti] = useState(false);
    const [isButtonDisabled, setButtonDisabled] = useState(false);
    const [startTime, setStartTime] = useState(null);
    const [chartData, setChartData] = useState(null);
    const [user, setUser] = useState(null);
    // const todaysDate = new TodaysDate();
    // const currentDate = todaysDate.getFormattedDate();
    const [showDislikeOptions, setShowDislikeOptions] = useState(false);
    const [dislikedReason, setDislikedReason] = useState(null);
    const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const hasprogress = JSON.parse(localStorage.getItem('progress'));
    const hasGuesses = hasprogress && hasprogress.guesses && hasprogress.guesses.length > 0;
    const [icon, setIcon] = useState('');

    const fetchUser = useCallback(async () => {
      try {
        const currentUser = await Auth.currentAuthenticatedUser();
        setUser(currentUser);
      } catch (error) {
        console.log('User data not fetched: ', error);
      }
    }, []);

    const fetchData = useCallback(async () => {
      try {
          const response = await axios.get('https://j82f3qhqn3.execute-api.us-east-1.amazonaws.com/prod');
          setData(response.data);
          setStartTime(Date.now());
          setIsLoading(false);
          const progress = localStorage.getItem('progress');
          const iconName = response.data.icon;
          setIcon(iconMapping[iconName])
          if (progress) {
            const storedData = JSON.parse(progress);
            if (storedData.date !== response.data.date) {
              localStorage.removeItem('progress');
            }
          }

          let riddleStatsInCookies = Cookies.get('riddleStats');
          if (riddleStatsInCookies) {
              const riddleStatsInLocalStorage = localStorage.getItem('riddleStats');
              if (!riddleStatsInLocalStorage) {
                  localStorage.setItem('riddleStats', riddleStatsInCookies);
              }
              Cookies.remove('riddleStats'); // Remove riddleStats from cookies after transferring to avoid duplicates
          }

          const riddleStats = localStorage.getItem('riddleStats') ? JSON.parse(localStorage.getItem('riddleStats')) : {};
          if (riddleStats[response.data.date]) {
              setGameOver(true);
              setTotalGuesses(riddleStats[response.data.date].guesses);
              if (riddleStats[response.data.date].solved) {
                  setMessage({ text: 'Correct!' });
              } else {
                  setMessage({ text: `Out of Guesses` });
              }
              showRiddleStats();
          }
      } catch (error) {
          console.error('There was an error!', error);
          setMessage({ text: 'AWS currently has an outage. Please check back later.' });
      }
    }, []); 
    

    useEffect(() => {
      if(!Cookies.get('userid')) {
          let userid = Math.random().toString(36).substring(2, 15);
          Cookies.set('userid', userid, { expires: 365 });
      }
      fetchUser();
      fetchData();
    }, [fetchUser, fetchData]);

    useEffect(() => {
      if (showConfetti) {
        const timer = setTimeout(() => {
          setShowConfetti(false);
        }, 5000);
  
        return () => clearTimeout(timer);
      }
    }, [showConfetti]);

    useEffect(() => {
      document.title = "Ridella";
    }, []);  

    useEffect(() => {
      let riddleStats = localStorage.getItem('riddleStats') ? JSON.parse(localStorage.getItem('riddleStats')) : {};
      console.log(user)
      const fetchData = async () => {
          if (user !== null) {
              try {
                  const response = await fetch(`https://e50k0bjhjl.execute-api.us-east-1.amazonaws.com/prod?username=${user.username}`);
                  const data = await response.json();
                  const updatedRiddleStats = {...riddleStats, ...data.riddleStats};
                  localStorage.setItem('riddleStats', JSON.stringify(updatedRiddleStats));
              } catch (error) {
                  console.error('Error:', error);
              }
          }
      };
      fetchData();
    }, [user]);

    useEffect(() => {
      const likedRiddle = async () => {
          if (dislikedReason !== null) {
              const userId = user && user.username ? user.username : Cookies.get('userid');
              try {
                  await axios.post('https://wbhsffi011.execute-api.us-east-1.amazonaws.com/prod', {
                      date: data.date,
                      userid: userId,
                      dislikedReason: dislikedReason
                  });
              } catch (error) {
                  console.error('There was an error!', error);
              }
          }
      };
  
      likedRiddle();
  }, [dislikedReason, data.date, user]);
  

    function storeProgress(value, timeTaken, date, wasCorrect) {
      var data = {
          'guesses': [],
          'timeTaken': 0,
          'date': date,
          'wasCorrect': wasCorrect
      };
      var storedData = localStorage.getItem('progress');
      if (storedData) {
          data = JSON.parse(storedData);
          if (data.date === date) {
              data.guesses.push(value);
              data.timeTaken += timeTaken;
              data.wasCorrect = wasCorrect;
          } else {
              data = {
                  'guesses': [value],
                  'timeTaken': timeTaken,
                  'date': date,
                  'wasCorrect': wasCorrect
              };
          }
      } else {
          data = {
              'guesses': [value],
              'timeTaken': timeTaken,
              'date': date,
              'wasCorrect': wasCorrect
          };
      }
      localStorage.setItem('progress', JSON.stringify(data));
    }  

    const handleSubmit = async (event) => {
      event.preventDefault();
      setButtonDisabled(true);
      const value = inputRef.current.value.trim().toLowerCase();
      setTotalGuesses(totalGuesses + 1);
      const wasCorrect = data.answers.some(answer => value.includes(answer.toLowerCase()));
      const timeTaken = (Date.now() - startTime) / 1000;
      const userId = user && user.username ? user.username : Cookies.get('userid');
      storeProgress(value, timeTaken, data.date, wasCorrect);
      try {
        await axios.post('https://a02dsya9ac.execute-api.us-east-1.amazonaws.com/prod', {
          date: data.date,
          userid: userId,
          guess: value,
          wasCorrect: wasCorrect,
          timeTaken: timeTaken,
          source: "mysite"
        });
      } catch (error) {
        console.error('There was an error!', error);
      }
      if (wasCorrect) {
        setMessage({ text: 'Correct!' });
        setGameOver(true);
        setShowConfetti(true);
        storeRiddleStats(totalGuesses, timeTaken, true);
        showRiddleStats();
        setTimeout(function() { window.refreshAdSlots(); }, 1000);
      } else {
        setMessage({ text: 'Try Again!' });
        inputRef.current.value = "";
        if (totalGuesses >= 3) {
          setMessage({ text: 'Out of Guesses' });
          setGameOver(true);
          storeRiddleStats(totalGuesses, timeTaken, false);
          showRiddleStats();
          setTimeout(function() { window.refreshAdSlots(); }, 1000);
        }
        setTimeout(() => {
          setButtonDisabled(false);
        }, 1500); 
      }
    };

    const storeRiddleStats = async (guesses, timeTaken, wasCorrect) => {
      const riddleStats = localStorage.getItem('riddleStats') ? JSON.parse(localStorage.getItem('riddleStats')) : {};
      if (!riddleStats[data.date]) {
        riddleStats[data.date] = {
            guesses: guesses + 1,
            timeTaken: timeTaken,
            solved: wasCorrect
        };
        localStorage.setItem('riddleStats', JSON.stringify(riddleStats), { expires: 365 });
      }
      if (user) {
        console.log('User is logged in:', user);
        try {
          await axios.post('https://mvoztqmfje.execute-api.us-east-1.amazonaws.com/prod', {
            username: user.username,
            date: data.date,
            guesses: guesses + 1,
            solved: wasCorrect,
            timeTaken: timeTaken
          });
        } catch (error) {
          console.error('There was an error!', error);
        }
      } else {
        console.log('User is not logged in');
      }
    }
    

    const showRiddleStats = () => {
      const riddleStats = localStorage.getItem('riddleStats') ? JSON.parse(localStorage.getItem('riddleStats')) : {};
      let guessCounts = [0, 0, 0, 0]; // Array to hold the count of correct guesses in 1, 2, 3, or 4 guesses
      let notSolvedCount = 0; // Variable to hold the count of not solved cases
      Object.values(riddleStats).forEach(stat => {
        if (stat.solved) {
          guessCounts[stat.guesses - 1]++;
        } else {
          notSolvedCount++;
        }
      });
      const data = ['1', '2', '3', '4'].map((guess, i) => ({ name: guess, count: guessCounts[i] }));
      data.push({ name: "NS", count: notSolvedCount }); // Add the not solved count to the data
      setChartData(data);
    };

    useEffect(() => {
      const storedData = JSON.parse(localStorage.getItem('progress'));
      if (storedData && storedData.date === data.date) {
          setTotalGuesses(storedData.guesses.length);
      }
    }, [data.date]);

    const renderLines = () => {
      if (isLoading) {
        return <p>Loading...</p>;
      }
      const lines = [data.firstLine, data.secondLine, data.thirdLine, data.fourthLine];
      const revealLines = gameOver ? 4 : totalGuesses + 1;
      return lines.map((line, index) => (
        <p key={index} className={revealLines > index ? "" : "blur-text"}>
          {line}
        </p>
      ));
    };    

    const [showInformation, setShowInformation] = useState(false);
    const [showExplanation, setShowExplanation] = useState(false);
    const handleShowInformation = () => setShowInformation(true);
    const handleCloseInformation = () => setShowInformation(false);
    const handleShowExplanation = () => setShowExplanation(true);
    const handleCloseExplanation = () => setShowExplanation(false);
    const [isPuzPopModalOpen, setIsPuzPopModalOpen] = useState(true);
    const handleClosePuzPopModal = () => {
      setIsPuzPopModalOpen(false);
    };

    return (
      <div className="main-container">
        <div
          className={`backdrop-test ${(showInformation || showExplanation) ? 'backdrop-show' : ''}`}
          onClick={() => {
            handleCloseInformation();
            handleCloseExplanation();
          }}
        ></div>
        <div className="center-content">
        {showConfetti && <Confetti recycle={false}/>}
        <Information show={showInformation} handleShow={handleShowInformation} handleClose={handleCloseInformation}/>
        <div className="header">
          {/* <p className="title">{currentDate}</p> */}
        </div>
        <div className="content">
          {renderLines()}
        </div>
          {!gameOver && (
            <form onSubmit={handleSubmit}>
              <InputSection inputRef={inputRef} disabled={gameOver || isButtonDisabled}/>
            </form>
          )}
          {gameOver && (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', marginTop: '20px' }}>
            <div className={`game-over-message ${message.text === "Correct!" ? "correct-result" : "incorrect-result"}`}>
              <span className="message-icon-result">
                {message.text === "Correct!" ? 
                  <CheckCircleFill className="icon-correct" /> : 
                  <XCircleFill className="icon-incorrect" />}
              </span>
              <span>{message.text}</span>
            </div >
            {/* <div style={{ marginLeft: '20px' }}>
              <ShareButton todaysRiddle={data} />
            </div> */}
            </div>
          )}
          {!hasGuesses && (
            <div className="solve-container">
              <div style={{ padding: '10px 20px 10px 20px', textAlign: 'center' }}>
                Solve the riddle in four tries.
                <div style={{ marginTop: '10px' }}>
                  <InformationButton show={showInformation} handleShow={handleShowInformation} handleClose={handleCloseInformation} />
                </div>
              </div>
            </div>
          )}
          {hasGuesses && !gameOver && (
            <div className="solve-container">
              <div style={{ fontSize: '16px', fontWeight: 'bold', textAlign: 'right', paddingRight: 5, paddingTop: 5 }}>
                {!gameOver && `${hasprogress?.guesses.length || 0}/4`}
              </div>
              <div className={message.status ? `${message.status}` : 'no-guesses'}>
                {!gameOver &&
                  <div style={{display: 'flex', textAlign: 'left', paddingLeft: 20, paddingBottom: 10, marginTop: '-15px'}}>
                    <div style={{fontWeight: 'bold'}}>
                      Guesses:
                      {hasprogress?.guesses.length > 0 ? (
                        hasprogress?.guesses.map((guess, index) => (
                          <div key={index}>{`${index + 1}. ${guess || '(blank)'}`}</div>
                        ))
                      ) : (
                        <div>None</div>
                      )}
                    </div>
                  </div>
                }
              </div>
            </div>
          )}
        {gameOver && 
          <>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingRight: 20, paddingLeft: 20, paddingBottom: 20, paddingTop: 15 }}>
              <div style={{ width: '50%', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <div>
                  <div style={{ fontSize: '16px' }}>Answer:</div>
                  <div style={{ fontWeight: 'bold', fontSize: '24px' }}>{data.answers[0]}</div>
                </div>
              </div>
              <div style={{ width: '50%', display: 'flex', justifyContent: 'center' }}>
                <FontAwesomeIcon icon={icon} style={{ fontSize: '54px', paddingRight: 30 }} />
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ paddingRight: 0 }}>
                <Explanation data={data} show={showExplanation} handleShow={handleShowExplanation} handleClose={handleCloseExplanation} />
              </div>
              <div style={{ paddingRight: 20, paddingLeft: 10, paddingTop: 18 }}>
                <ShareButton todaysRiddle={data} />
              </div>
            </div>
            <div style={{ paddingRight: 0, display: 'flex', justifyContent: 'center' }}>
                <PlayUnlimited />
            </div>
            <div className="feedback-container">
              {feedbackSubmitted ? (
                <div className="feedback-submitted">
                  <Check size={52} />
                  <p>Thanks for the feedback!</p>
                </div>
              ) : (
                <>
                  <p>Did you like today's riddle?</p>
                  <div className="button-group">
                    <Button style={{ backgroundColor: 'white', color: 'green', border: '1px solid green', borderRadius: '25px' }} variant="contained" startIcon={<HandThumbsUp />} onClick={() => { setDislikedReason("Liked"); setFeedbackSubmitted(true); }}>Like</Button>
                    <Button style={{ backgroundColor: 'white', color: '#f4504f', border: '1px solid #f4504f', borderRadius: '25px' }} variant="contained" startIcon={<HandThumbsDown />} onClick={() => setShowDislikeOptions(true)}>Dislike</Button>
                  </div>
                  {showDislikeOptions && (
                    <div className="feedback-container">
                      <p>Why didn't you like it?</p>
                      <div className="dislike-options">
                        <Button style={{ backgroundColor: 'white', color: '#7d79d2', border: '1px solid #7d79d2', textTransform: 'none' }} variant="outlined" onClick={() => { setDislikedReason('Too easy'); setFeedbackSubmitted(true); }}>Too easy</Button>
                        <Button style={{ backgroundColor: 'white', color: '#7d79d2', border: '1px solid #7d79d2', textTransform: 'none' }} variant="outlined" onClick={() => { setDislikedReason('Too hard'); setFeedbackSubmitted(true); }}>Too hard</Button>
                        <Button style={{ backgroundColor: 'white', color: '#7d79d2', border: '1px solid #7d79d2', textTransform: 'none' }} variant="outlined" onClick={() => { setDislikedReason("Didn't accept my answer"); setFeedbackSubmitted(true); }}>Didn't accept my answer</Button>
                      </div>
                    </div>
                  )}
                </>
              )}
              <div className="postgame_mpu1">
                <div id="nn_mobile_mpu1"></div>
              </div>
            </div>
            <PuzPopModal 
                open={isPuzPopModalOpen} 
                onClose={handleClosePuzPopModal}
            />
            {/* <PostGameAlert /> */}
          </>
        }
        {/* {!gameOver && <PreGameAlert />} */}
        {chartData && 
          <Statistics chartData={chartData} todaysRiddle={data} username={user?.username} />
        }
        {/* {isSmallScreen && <Footer />} */}
      </div>
      <div className="right-content">
        <div id="nn_mpu1"></div>
      </div>
      </div>
    );
};

function InputSection({ inputRef, disabled }) {

  const SolveButton = styled(Button)({
      backgroundColor: 'white',
      color: '#7D79D2',
      borderRadius: '25px',
      width: '120px',
      textAlign: 'center',
      margin: '20px 0 20px 10px',
      cursor: 'pointer',
      fontSize: '18px',
      textTransform: 'none',    
      fontFamily: 'Comfortaa, sans-serif',
      border: '2px solid #7D79D2',
      fontWeight: 700,
      '&:hover': {
          backgroundColor: '#7D79D2',
          color: 'white',
          border: '2px solid #5B5FB6',          
      },
  });

  return (
      <div className="input-section">
          <input type="text" ref={inputRef} disabled={disabled} maxLength={20} />
          <SolveButton type="submit" disabled={disabled}>
              Solve
          </SolveButton>
      </div>
  );
}

const pulseAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`;

function PlayUnlimited() {

  const PlayUnlimitedButton = styled(Button)({
      backgroundColor: '#7D79D2',
      color: 'white',
      borderRadius: '25px',
      textAlign: 'center',
      margin: '20px 0 20px 10px',
      cursor: 'pointer',
      fontSize: '18px',
      textTransform: 'none',    
      fontFamily: 'Comfortaa, sans-serif',
      border: '2px solid #5B5FB6',
      fontWeight: 700,
      padding: '10px 10px',
      animation: `${pulseAnimation} 2s infinite`,
      '&:hover': {
          backgroundColor: 'white',
          color: '#7D79D2',
          border: '2px solid #7D79D2',       
      },
  });

  const navigate = useNavigate();

  const handlePlayUnlimitedClick = () => {
    console.log(typeof window.reloadAdSlots)
    if (typeof window.reloadAdSlots === 'function') {
      window.reloadAdSlots();
    }
    navigate('/unlimited');
    actionCounter('hitPlayUnlimited');
  };

  return (
      <div>
        <PlayUnlimitedButton onClick={handlePlayUnlimitedClick}>
            Play Unlimited
        </PlayUnlimitedButton>
      </div>
  );
}

function actionCounter(userAction) {
  const apiUrl = "https://7z7przcw81.execute-api.us-east-1.amazonaws.com/prod";
  const params = {
      action: userAction
  };
  fetch(apiUrl, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(params)
  })
  .then(response => response.json())
  .catch(error => {
    console.error('Error incrementing counter:', error);
  });
}

export default Ridella;
